export const formatDollarAmount = (amount: number) => {
  if (!amount) return "Unknown";

  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
  });
};
